import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface CustomTooltipProps {
  title: React.ReactNode;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ title, ...props }) => {
  return (
    <AntdTooltip
      title={title}
      color="white"
      overlayInnerStyle={{
        padding: '10px',
        width:'500px',
        fontSize: '14px',
        color: '#000',
        border: '1px solid #d9d9d9',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
      {...props}
    >
      <InfoCircleOutlined
        style={{
          marginLeft: '8px',
          fontSize: '18px',
          color: '#1890ff',
          cursor: 'pointer',
        }}
      />
    </AntdTooltip>
  );
};

export default CustomTooltip;
